import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import {
  styled,
  useTheme,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  Button,
  Box,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ArrowBack } from '@mui/icons-material';

import { useGetItineraryById } from '@frontend/features/flight/queries';

import { routes } from '../routes';

const PaymentDetailRow = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

const Mevuelogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="132" height="42" viewBox="0 0 132 42" fill="none">
    <path d="M101.888 31.6905L100.311 35.5117L100.535 35.6038L102.112 31.7826L101.888 31.6905Z" fill="#FCB427" />
    <path d="M102.862 31.9823L101.896 37.5059L102.135 37.5474L103.101 32.0238L102.862 31.9823Z" fill="#FCB427" />
    <path d="M104.092 32.1568L103.852 32.1865L104.36 36.2877L104.601 36.258L104.092 32.1568Z" fill="#FCB427" />
    <path d="M104.537 41.4999L99.3035 40.8024L99.2246 35.2607L105.925 35.9688L104.537 41.4999Z" fill="#B90071" />
    <path
      d="M103.774 29.7253C104.285 29.9613 104.745 29.9248 105.196 29.1547C107.41 25.3836 109.638 21.5995 111.168 17.4702C112.736 13.2249 113.48 8.85101 112.776 4.31405C112.674 3.65764 112.463 3.02697 112.304 2.38343C113.58 2.5486 115.514 4.15316 115.865 5.3716C116.544 7.73125 116.452 10.0909 115.978 12.4634C115.049 17.1193 112.921 21.4466 109.808 25.0103C108.442 26.5977 107.072 28.1851 105.634 29.8519L106.291 29.9184C105.83 30.7485 105.4 31.5487 104.934 32.3274C104.878 32.4038 104.806 32.4667 104.722 32.5115C104.639 32.5564 104.547 32.5822 104.453 32.5869C103.725 32.5787 103 32.4961 102.289 32.3402C101.923 32.2416 101.417 31.8447 101.364 31.5165C100.824 28.2752 99.3023 25.3707 98.3087 22.2924C96.6386 17.1184 96.3514 11.9314 97.8534 6.68657C98.3844 4.82872 99.3223 3.11479 100.598 1.67124C100.814 1.40354 101.081 1.18241 101.384 1.02099C101.687 0.859583 102.018 0.761192 102.36 0.731675C103.126 0.660885 103.9 0.58366 104.764 0.5C101.713 3.96654 100.696 8.11523 100.151 12.4098C99.4597 17.8799 100.462 23.2513 101.345 28.6141C101.406 28.9917 102.026 29.2748 102.385 29.6009L102.636 29.4679C102.717 28.3331 102.8 27.1983 102.877 26.0636C103.319 19.6003 103.657 13.122 105.166 6.79597C105.61 4.93399 106.342 3.14924 106.955 1.32159C107.125 0.832496 107.444 0.714513 107.976 0.826061C109.834 1.19931 109.997 1.22935 109.825 3.22861C109.612 5.80277 109.385 8.42198 108.761 10.9232C107.223 17.202 105.462 23.4229 103.774 29.7253ZM92.9707 12.251C92.9707 16.3096 94.8706 19.5896 97.1875 22.7215C94.209 16.8095 93.1239 10.7666 95.8599 4.42989C94.0473 6.72089 92.9665 9.27575 92.9707 12.251ZM111.627 24.8945C112.415 24.3119 113.171 23.6875 113.893 23.0239C116.212 20.9045 118.344 18.6393 119.337 15.5438C120.065 13.2764 119.859 11.0562 118.897 8.87675C119.274 15.5159 116.061 20.4798 111.627 24.8945Z"
      fill="#FCB427"
    />
    <path
      d="M2.63851 28.9034V30.2192H2.69197C3.01078 29.7024 3.45954 29.2788 3.99328 28.9906C4.52701 28.7025 5.12695 28.5601 5.73294 28.5776C6.45325 28.5696 7.16242 28.7561 7.78591 29.1177C8.3893 29.4671 8.88559 29.9755 9.22085 30.5878C9.57554 29.9362 10.1243 29.4118 10.7905 29.0877C11.4783 28.7465 12.2364 28.5718 13.0039 28.5776C15.687 28.5776 17.0286 30.2713 17.0286 33.6587V41.5001H14.89V33.9995C14.8944 33.5859 14.8765 33.1724 14.8366 32.7608C14.7904 32.3901 14.7006 32.0261 14.5693 31.6764C14.4447 31.3047 14.1923 30.9895 13.8571 30.7871C13.4643 30.573 13.0208 30.4701 12.574 30.4892C12.0622 30.4698 11.5553 30.5954 11.1113 30.8514C10.7269 31.0922 10.434 31.4551 10.2794 31.8822C10.1195 32.2977 10.0027 32.7285 9.93084 33.168C9.86409 33.6465 9.83264 34.1293 9.83674 34.6124V41.5001H7.69823V34.1495C7.69823 31.7064 6.9469 30.4849 5.44424 30.4849C4.91836 30.4667 4.39846 30.6015 3.94728 30.8728C3.54833 31.1273 3.24689 31.5094 3.09188 31.9572C2.92863 32.3887 2.81108 32.8362 2.74116 33.2923C2.67392 33.7801 2.64248 34.2721 2.64707 34.7645V41.4958H0.5V28.9034H2.63851Z"
      fill="#FF0000"
    />
    <path
      d="M32.1999 35.6896H22.3419C22.339 36.2102 22.4413 36.7263 22.6431 37.2078C22.8448 37.6893 23.142 38.1267 23.5172 38.4946C23.9004 38.8735 24.3591 39.1706 24.8647 39.3673C25.3703 39.5641 25.9119 39.6562 26.4554 39.6379C28.0409 39.6379 29.3184 38.8248 30.2879 37.1987L32.1041 38.179C30.8394 40.3917 28.9068 41.4988 26.3064 41.5002C24.4711 41.5002 22.9885 40.9171 21.8586 39.7508C20.7287 38.5845 20.161 37.1381 20.1553 35.4116C20.1553 33.5848 20.6989 32.0625 21.7862 30.8446C22.8735 29.6267 24.3639 29.0192 26.2574 29.022C28.1992 29.022 29.7038 29.6713 30.7712 30.97C31.8386 32.2687 32.3149 33.8419 32.1999 35.6896ZM22.4484 33.9777H29.9558C29.8214 33.1193 29.3752 32.3375 28.6996 31.7768C28.0323 31.1908 27.1655 30.8716 26.2702 30.8822C25.347 30.8785 24.4531 31.2004 23.7514 31.7894C23.0465 32.3271 22.5798 33.1109 22.4484 33.9777Z"
      fill="#FCB427"
    />
    <path
      d="M35.5813 28.5762L39.3795 36.7206L43.1778 28.5762H45.6185L39.3795 41.5001L33.1104 28.5762H35.5813Z"
      fill="#EDE956"
    />
    <path
      d="M49.5359 28.5762V35.7952C49.5359 36.2585 49.5485 36.6531 49.5759 36.9834C49.606 37.3303 49.6767 37.6723 49.7864 38.0021C49.8792 38.3183 50.0371 38.6108 50.2496 38.86C50.478 39.0996 50.7586 39.2811 51.0686 39.3897C51.8895 39.6623 52.7741 39.6623 53.595 39.3897C53.9048 39.2805 54.1852 39.0991 54.414 38.86C54.6265 38.6108 54.7844 38.3183 54.8772 38.0021C54.9869 37.6723 55.0576 37.3303 55.0877 36.9834C55.1151 36.6552 55.1277 36.2585 55.1277 35.7952V28.5762H57.2331V36.0268C57.2331 39.6771 55.5951 41.5015 52.3192 41.5001C49.0432 41.4986 47.4053 39.6742 47.4053 36.0268V28.5762H49.5359Z"
      fill="url(#paint0_linear_388_85455)"
    />
    <path
      d="M72.4084 35.6896H62.5563C62.5542 36.2103 62.6572 36.7262 62.8591 37.2077C63.0611 37.6891 63.3581 38.1265 63.733 38.4946C64.1157 38.8738 64.5742 39.1711 65.0795 39.3679C65.5849 39.5646 66.1262 39.6566 66.6695 39.6379C68.2526 39.6379 69.5251 38.8248 70.4869 37.1987L72.302 38.179C71.038 40.3917 69.1066 41.4988 66.5078 41.5002C64.6764 41.5002 63.1947 40.9171 62.0626 39.7508C60.9306 38.5845 60.3632 37.1381 60.3604 35.4116C60.3604 33.5848 60.903 32.0625 61.9882 30.8446C63.0734 29.6267 64.5593 29.0192 66.4461 29.022C68.3867 29.022 69.8911 29.6713 70.9593 30.97C72.0275 32.2687 72.5105 33.8419 72.4084 35.6896ZM62.6648 33.9777H70.1656C70.0311 33.1198 69.5861 32.3383 68.9123 31.7768C68.2445 31.1909 67.3776 30.8717 66.4822 30.8822C65.5619 30.8807 64.6714 31.2025 63.9714 31.7894C63.2643 32.3255 62.796 33.1098 62.6648 33.9777Z"
      fill="#71BCED"
    />
    <path d="M77.3352 20.5542V41.4998H75.1016V20.5542H77.3352Z" fill="url(#paint1_linear_388_85455)" />
    <path
      d="M91.5341 39.6885C90.2882 40.8526 88.6461 41.5002 86.9403 41.5002C85.2345 41.5002 83.5924 40.8526 82.3465 39.6885C81.7408 39.1281 81.2601 38.4464 80.9357 37.688C80.6113 36.9296 80.4505 36.1114 80.4638 35.2868C80.4495 34.4561 80.6097 33.6317 80.934 32.8667C81.2583 32.1017 81.7394 31.4132 82.3465 30.8454C83.5888 29.6743 85.2323 29.022 86.9403 29.022C88.6483 29.022 90.2918 29.6743 91.5341 30.8454C92.1412 31.4132 92.6223 32.1017 92.9466 32.8667C93.2709 33.6317 93.4311 34.4561 93.4168 35.2868C93.4301 36.1114 93.2692 36.9296 92.9449 37.688C92.6205 38.4464 92.1398 39.1281 91.5341 39.6885ZM90.0886 32.1538C89.2432 31.3386 88.1141 30.8831 86.9393 30.8831C85.7644 30.8831 84.6353 31.3386 83.7899 32.1538C82.9973 32.9945 82.556 34.1058 82.556 35.2607C82.556 36.4155 82.9973 37.5269 83.7899 38.3675C84.6353 39.1827 85.7644 39.6382 86.9393 39.6382C88.1141 39.6382 89.2432 39.1827 90.0886 38.3675C90.8812 37.5269 91.3225 36.4155 91.3225 35.2607C91.3225 34.1058 90.8812 32.9945 90.0886 32.1538Z"
      fill="#8167A3"
    />
    <path
      d="M113.928 35.859V37.1933H113.904C113.396 36.5308 112.796 36.1995 112.106 36.1995C111.833 36.1925 111.563 36.2457 111.311 36.3557C111.06 36.4657 110.833 36.63 110.646 36.8379C110.456 37.0424 110.307 37.2845 110.206 37.5501C110.106 37.8157 110.057 38.0995 110.062 38.3851C110.051 38.9556 110.249 39.5089 110.616 39.9301C110.797 40.1404 111.02 40.3064 111.269 40.4167C111.518 40.527 111.787 40.5788 112.057 40.5686C112.426 40.5683 112.789 40.4757 113.116 40.2984C113.444 40.1211 113.726 39.8642 113.94 39.5492H113.967V40.8942C113.425 41.2829 112.786 41.4933 112.13 41.4986C111.726 41.5106 111.323 41.4377 110.945 41.2843C110.568 41.1308 110.224 40.8998 109.933 40.6048C109.652 40.3145 109.429 39.9682 109.278 39.5862C109.127 39.2043 109.051 38.7944 109.053 38.3808C109.055 37.9672 109.136 37.5582 109.292 37.1781C109.447 36.798 109.673 36.4544 109.957 36.1676C110.484 35.6444 111.166 35.3275 111.889 35.2702C112.612 35.2128 113.332 35.4185 113.928 35.8526V35.859Z"
      fill="#B90071"
    />
    <path
      d="M120.649 40.5953C120.052 41.176 119.259 41.4999 118.434 41.4999C117.609 41.4999 116.816 41.176 116.218 40.5953C115.924 40.3131 115.692 39.9713 115.535 39.5919C115.378 39.2125 115.3 38.8039 115.307 38.3921C115.299 37.9777 115.376 37.5662 115.533 37.1839C115.69 36.8016 115.923 36.4569 116.218 36.1719C116.814 35.5873 117.608 35.2607 118.434 35.2607C119.26 35.2607 120.054 35.5873 120.649 36.1719C120.944 36.4569 121.177 36.8016 121.334 37.1839C121.491 37.5662 121.568 37.9777 121.56 38.3921C121.567 38.8039 121.489 39.2125 121.333 39.5919C121.176 39.9713 120.943 40.3131 120.649 40.5953ZM119.953 36.8275C119.548 36.4196 119.002 36.1909 118.434 36.1909C117.865 36.1909 117.319 36.4196 116.914 36.8275C116.532 37.2505 116.32 37.8049 116.32 38.3804C116.32 38.9559 116.532 39.5102 116.914 39.9333C117.319 40.3412 117.865 40.5699 118.434 40.5699C119.002 40.5699 119.548 40.3412 119.953 39.9333C120.335 39.5102 120.547 38.9559 120.547 38.3804C120.547 37.8049 120.335 37.2505 119.953 36.8275Z"
      fill="#B90071"
    />
    <path
      d="M123.934 35.8648V36.4718H123.962C124.114 36.2331 124.331 36.0366 124.59 35.9023C124.85 35.7679 125.143 35.7005 125.439 35.707C125.79 35.703 126.137 35.7898 126.44 35.9579C126.735 36.1208 126.977 36.3566 127.139 36.6398C127.311 36.3391 127.578 36.0964 127.904 35.9457C128.237 35.7869 128.606 35.705 128.98 35.707C130.289 35.707 130.943 36.4921 130.941 38.0622V41.4818H129.895V38.2201C129.897 38.0282 129.888 37.8364 129.869 37.6454C129.847 37.474 129.803 37.3056 129.74 37.1436C129.678 36.9752 129.555 36.8322 129.393 36.7389C129.203 36.641 128.988 36.5934 128.771 36.6013C128.522 36.5922 128.274 36.6505 128.059 36.7693C127.871 36.8813 127.728 37.0494 127.654 37.2468C127.574 37.4427 127.517 37.6462 127.484 37.8538C127.451 38.0757 127.435 38.2995 127.436 38.5236V41.5H126.392V38.2909C126.392 37.1591 126.026 36.5932 125.292 36.5932C125.041 36.5891 124.793 36.653 124.58 36.7774C124.384 36.8958 124.237 37.0726 124.162 37.2792C124.082 37.48 124.025 37.6883 123.992 37.9004C123.959 38.1263 123.943 38.3542 123.945 38.5822V41.4879H122.9V35.8648H123.934Z"
      fill="#B90071"
    />
    <defs>
      <linearGradient
        id="paint0_linear_388_85455"
        x1="52.336"
        y1="41.5001"
        x2="52.336"
        y2="28.5762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8CB236" />
        <stop offset="1" stopColor="#8CB236" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_388_85455"
        x1="76.2139"
        y1="41.4893"
        x2="76.2139"
        y2="20.5437"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006492" />
        <stop offset="1" stopColor="#006492" />
      </linearGradient>
    </defs>
  </svg>
);

// TODO: Placeholder. Refactorear para matchear UI del voucher de flights.
export const FlightPayment = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const { id: bookingId } = useParams<{ id: string }>();

  const queryParams = useMemo(() => (bookingId ? { id: parseInt(bookingId, 10) } : { id: 0 }), [bookingId]);

  // TODO: usar useGetBookingById cuando lo tenga implementado,
  // por ahora como no tenemos ni pagos ni bookings por agencia,
  // uso la data del itinerario mismo para mostrar algo.
  const { data } = useGetItineraryById(queryParams.id);

  const price = parseInt(data?.data.price || '');
  const currency = data?.data.currency;

  // TODO: Los siguientes valores ya deberian venir calculados de alguna manera
  // TODO: Los siguientes valores ya deberian venir calculados de alguna manera
  // TODO: Los siguientes valores ya deberian venir calculados de alguna manera
  // TODO: Los siguientes valores ya deberian venir calculados de alguna manera
  const serviceFare = Math.ceil(price * 0.1);
  const taxes = Math.ceil(price * 0.15);

  const goToVoucher = useCallback(() => {
    if (bookingId) {
      // TODO: Esto eventualmente deberia ser un payment id despues de
      // crear una nueva entrada de pago, y pasarle al voucher view
      // asi puede hacer fetch junto con el itinerario y mostrar todo.
      const path = routes.flights.voucher.replace(':id', bookingId.toString());
      navigate(path);
    }
  }, [queryParams, bookingId]);

  return (
    <Box>
      <AppBar position="static" color="primary">
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="back">
            <ArrowBack />
          </IconButton>
          <Typography variant="body1" color="primary.contrastText">
            {t('flights.payment.summary')}
          </Typography>
        </Toolbar>
      </AppBar>

      <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
        <CheckCircleIcon sx={{ fontSize: 100, color: theme.palette.success.main }} />
        <Typography variant="h6" color="text.primary">
          {t('flights.payment.success').toUpperCase()}
        </Typography>

        <Card elevation={4} sx={{ padding: '30px 20px', marginTop: '40px', minWidth: '310px' }}>
          <CardContent sx={{ padding: 0 }}>
            <Box display="flex" flexDirection="column" rowGap={2}>
              <Box display="flex" justifyContent="center" mb={2}>
                <Mevuelogo />
              </Box>
              <PaymentDetailRow>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {t('flights.payment.method')}:
                </Typography>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  VISA
                </Typography>
              </PaymentDetailRow>
              <PaymentDetailRow>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {t('flights.payment.yours')}:
                </Typography>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {currency} {price}
                </Typography>
              </PaymentDetailRow>
              <PaymentDetailRow>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {t('flights.payment.serviceFare')}:
                </Typography>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {currency} {serviceFare}
                </Typography>
              </PaymentDetailRow>
              <PaymentDetailRow>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {t('flights.payment.taxes')}:
                </Typography>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {currency} {taxes}
                </Typography>
              </PaymentDetailRow>
              <PaymentDetailRow>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  {t('flights.payment.date')}:
                </Typography>
                <Typography fontSize="14px" variant="body1" color="text.secondary">
                  15 Sep 2023
                </Typography>
              </PaymentDetailRow>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              bgcolor="paper.dark"
              border={`1px solid ${theme.palette.alphas.divider}`}
              borderRadius="8px"
              p="10px 20px"
              my="30px"
            >
              <Typography component="span" variant="body1" color="primary.main">
                {t('flights.payment.total').toUpperCase()}
              </Typography>
              <Typography component="span" variant="body1" color="primary.main">
                {currency} {price + serviceFare + taxes}
              </Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ borderRadius: '4px' }}
              onClick={goToVoucher}
            >
              {t('common.accept').toUpperCase()}
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};
